export const CSB = {
    page: 'customer-shipping-bans-page',
    titleMain: 'customer-shipping-bans-page__title-main',
    titleCargoCompanies: 'customer-shipping-bans-page__title-cargo-companies',
    switchesGrid: 'customer-shipping-bans-page__switches-grid',
    switchRow: 'customer-shipping-bans-page__switch-row',
    fieldCargoCompanyLabel: 'customer-shipping-bans-field--cargo-company-label',
    inputSwitchCargoBan: 'customer-shipping-bans-input--switch-cargo-ban',
    titleHistory: 'customer-shipping-bans-page__title-history',
    historySection: 'customer-shipping-bans-page__history-section',
    datagridHistory: 'customer-shipping-bans-page__datagrid-history',
} as const;

export const csbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
